import { getCloudflareUrl } from '../ui/utils/cloudflareCDN';

const siteUrl = process.env.REACT_APP_API_BASE_URL || 'https://jiddufilms.com';

const seoConfig = {
  siteUrl,
  siteName: process.env.REACT_APP_SITE_NAME || 'Jiddu Films',
  defaultTitle: process.env.REACT_APP_DEFAULT_TITLE || 'Jiddu Films — Creative Production Company in Miami | Visual Direction & Real-Time Content',
  defaultDescription: process.env.REACT_APP_DEFAULT_DESCRIPTION || 'JIDDU FILMS is a creative production company based in Miami, focused on visual direction, content creation, and real-time delivery.',
  defaultImage: process.env.REACT_APP_DEFAULT_IMAGE || getCloudflareUrl('https://jiddufilms-bucket.s3.us-east-2.amazonaws.com/JidduFilms_SocialShare.png'),
};

export default seoConfig;


